import styled from '@emotion/styled'

export const StyleWrapper = styled.div<any>`
  align-items: ${(props: any) => (!!props.isOwner ? 'flex-end' : 'flex-start')};
  display: flex;
  flex-direction: column;
`

export const StyleColumn = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyleMessageItemWrapper = styled.div`
  display: flex;
  column-gap: 10px;
  align-items: flex-start;
`
export const StyleMessage = styled.div<any>`
  background: ${(props: any) =>
    props.theme.colors[!!props?.isOwner ? 'secondary' : 'primary600']};
  padding: 10px 10px;
  border-radius: ${(props: any) =>
    !!props.isOwner ? '16px 16px 0px  16px' : '0px 12px 12px  12px'};
  font-size: 14px;
  color: ${(props: any) =>
    props.theme.colors[!!props?.isOwner ? 'white' : 'text']};
`

export const StyleTimeWrapper = styled.div<any>`
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const StyleMessageFileGrid = styled.div<any>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5px;
  justify-content: end;
  align-content: end;
`

export const StyleMessageFileItem = styled.div<any>`
  cursor: pointer;
`

export const StyleMessageImage = styled.img`
  width: 150px;
  height: 150px;
  border-radius: 4px;
  object-fit: cover;
`
export const StyleMessageFile = styled.div`
  padding: 5px 10px;
  border-radius: 4px;
  max-width: 200px;
  height: 50px;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  column-gap: 5px;
  oveflow: hidden;
`

export const StyleCallRow = styled.div`
  display: flex;
  column-gap: 10px;
  align-items: center;
`
